import { render } from "./GuaranteedIncome.vue?vue&type=template&id=14eb2954&scoped=true&ts=true"
import script from "./GuaranteedIncome.vue?vue&type=script&lang=ts"
export * from "./GuaranteedIncome.vue?vue&type=script&lang=ts"

import "./GuaranteedIncome.vue?vue&type=style&index=0&id=14eb2954&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14eb2954"]])

export default __exports__